// Copyright (c) 2017 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../../actions-list';
import {getAdjustmentTypes} from '../../shared/repositories';

export const readAdjustmentTypes = () =>
    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const data = await getAdjustmentTypes();

            dispatch({
                data,
                type: actions.UPDATE_TCSM_PARTIAL_DEBIT_ADJUSTMENT_TYPE_COLLECTION
            });

        } catch (error) {

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/tcsm/partial-debit/action-creators/adjustment-types.js